import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';

export default function Picker({ nome, dataStato, handleDateChange }) {
    return (

        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                format="dd/MM/yyyy"
                //OpenPickerButtonProps={{component: 'label'}}
                label={nome}
                value={new Date(dataStato)}
                onChange={(date) => handleDateChange(date, 0)}
                //renderInput={(params) => <TextField {...params} sx={{ width: 160 }} />}
                slots={{
                    textField: TextField,
                }}
                slotProps={{
                    textField: {
                        sx: { width: 160 },
                    },
                }}
            />

        </LocalizationProvider>



    )
}

